import type { Event, EventPayload } from 'effector'
import type { RouterResponse } from './router'

import { launch } from 'effector'

/*
 * Basic router hooks support.
 * Any module can register hooks on `init` and/or `left` events from navigation process.
 * Hooks are called before calling route's corresponding events,
 * but cannot interfere with the navigation process, and cannot block it.
 * Also, hooks are not awaited (thus they are Events, not Effects).
 */

export const Init = Symbol('init')
export const Left = Symbol('left')

type HooksMap = {
  [Init]: Event<{ route?: RouterResponse } | void>
  [Left]: Event<{ route?: RouterResponse; to?: RouterResponse } | void>
}

const hooks: Map<keyof HooksMap, Array<HooksMap[keyof HooksMap]>> = new Map()

export function register<T extends keyof HooksMap>(
  hook: T,
  handler: HooksMap[T]
) {
  const arr = hooks.get(hook)
  if (arr) {
    arr.push(handler)
  } else {
    hooks.set(hook, [handler])
  }
}

export function trigger<T extends keyof HooksMap>(
  hook: T,
  params: EventPayload<HooksMap[T]>
): void {
  const handlers = hooks.get(hook)
  if (handlers) {
    launch({
      target: handlers,
      params: new Array(handlers.length).fill(params),
    })
  }
}
